import Alert from 'antd/es/alert';

import './ErrorAlert.scss';

export const ErrorAlert = ({ message }: { message: string }) => {
  return (
    <div className="error" data-testid="error-alert">
      <Alert type="error" title={message} showIcon />
    </div>
  );
};
